module.exports = __webpack_public_path__ + "img/FR16668.386515bb.png";